export default class LocalStorage {
  static get(name) {
    return localStorage.getItem(name);
  }

  static save(name, value) {
    localStorage.setItem(name, value);
  }

  static remove(name) {
    localStorage.removeItem(name);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/StorageHandler/LocalStorage.js